<template>
  <AppDialog
    v-model="visible"
    title="选择任务"
    width="1230px"
    :loading="sureLoading"
    height="auto"
    :top="top"
    @success="sure"
  >
    <!-- 选择直播间弹框 -->
    <div class="selectTask">
      <div class="filterHeader">
        <div class="filterRow">
          <span class="formLabel">任务名称</span>
          <el-input
            v-model.trim="search.taskName"
            size="small"
            placeholder="请输入任务名称"
            style="width: 200px"
            class="m-r-10"
            clearable
            @keyup.enter.native="searchFn"
            @clear="searchFn"
          />
          <span class="formLabel">任务创建时间</span>
          <el-date-picker
            v-model="search.time.value"
            size="small"
            class="input-with-time m-r-10"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :unlink-panels="true"
            @change="handleClickSearch"
          />
          <span class="formLabel">创建人</span>
          <el-select
            v-model="search.userIds"
            size="small"
            filterable
            placeholder="请选择"
            clearable
            @change="searchFn"
          >
            <el-option
              v-for="item in userArray"
              :key="item.userId"
              :label="item.nickName"
              :value="item.userId"
            />
          </el-select>
          <el-button
            size="small"
            class="m-l-10"
            type="primary"
            @click="searchFn"
          >搜索</el-button>
        </div>
        <!-- <div class="checkboxRow">
          <el-checkbox
            v-model="search.filterTeacher"
            :true-label="1"
            :false-label="0"
            class="pr20"
            @change="selectedRelationTask"
          >
            仅关联助教线索
          </el-checkbox>
          <span class="filterRefundWrapper">
            <el-checkbox
              v-model="search.filterRefund"
              :true-label="1"
              :false-label="0"
              @change="selectedRelationTask"
            >
              是否过滤退款线索
            </el-checkbox>
            <el-tooltip
              class="item"
              effect="dark"
              placement="top-start"
              content="新产生退款的线索，不会加入本次计划看播。已经加入计划看播的线索，就算后续订单退款，也不会自动移除。"
            >
              <i class="el-icon-question"></i>
            </el-tooltip>
          </span>
        </div> -->
      </div>
      <div v-loading="loading" class="myTable">
        <div class="taskLayout">
          <div class="taskLayout__left">
            <el-table
              height="100%"
              :header-cell-style="{ background: '#F3F3F3' }"
              :data="list"
              @row-click="rowClick"
            >
              <el-table-column width="80" align="center">
                <template slot-scope="{ row }">
                  <el-checkbox
                    :value="selectIdsList.includes(row.id)"
                    @change="rowClick(row)"
                  />
                </template>
              </el-table-column>
              <el-table-column
                label="任务名称"
                prop="taskName"
                min-width="190px"
                show-overflow-tooltip
              />
              <el-table-column label="创建人" prop="createUserName" />
              <el-table-column label="创建时间" prop="createTime" min-width="152px">
                <template slot-scope="{ row }">
                  {{ moment(row.createTime).format('YYYY-MM-DD HH:mm:ss') }}
                </template>
              </el-table-column>
            </el-table>
            <div class="pagination">
              <div class="tipsError">
                <span class="tips">已选{{ selectList.length }}项</span>
                <span
                  v-if="selectList.length > 50"
                  class="m-l-10"
                >您关联的任务超过50个，请重新选择！</span>
              </div>
              <el-pagination
                :current-page="currentPage"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                :pager-count="5"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
              />
            </div>
          </div>
          <div
            v-if="selectList.length"
            class="selectedTaskList taskLayout__right"
          >
            <div class="selectedTaskList__title">已选任务</div>
            <div class="selectedTaskList__summary">已选 {{ selectList.length }} 项</div>
            <div class="selectedTaskTableHeader">
              <div class="selectedTaskTableHeader__cell">任务</div>
              <div
                class="selectedTaskTableHeader__cell selectedTaskTableHeader__follow"
              >
                <span>对应跟进人</span>
              </div>
            </div>
            <div class="selectedTaskList__body">
              <div
                v-for="task in selectedTasks"
                :key="task.id || task.taskId"
                class="selectedTaskRow"
              >
                <div class="selectedTaskRow__task">
                  <el-tag
                    closable
                    size="small"
                    class="m-b-10"
                    @close="removeSelectedTag(task)"
                  >
                    <span class="selectedTaskNameText" :title="task.taskName">
                      {{ task.taskName }}
                    </span>
                  </el-tag>
                </div>
                <div class="selectedTaskRow__follow">
                  <template
                    v-if="task.followUserList && task.followUserList.length"
                  >
                    <div
                      v-for="u in task.followUserList"
                      :key="`${task.id || task.taskId}-${u.followUserId || u.followUserName}`"
                      class="followUserItem"
                    >
                      <el-tag size="small">
                        {{ u.followUserName || '无' }}
                      </el-tag>
                    </div>
                  </template>
                  <span v-else class="selectedTaskRow__followEmpty">无</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div slot="footer">
      <div class="ss-material-box-bottom">
        <el-button type="primary" size="small" @click="sure">确认</el-button>
        <el-button size="small" @click="closeFn">取消</el-button>
      </div>
    </div>
  </AppDialog>
</template>

<script>
import { getOptionsValueByKey } from '@/filters/index'
import AppDialog from '@/components/AppDialog'
import { userNoPage, selectedRelationTask } from '@/api/addressBookApi'
import { saleTaskPage } from '@/api/liveRoom/index.js'
import { liveModeOption } from '@/views/live/columns.js'
import moment from 'moment'
export default {
  components: {
    AppDialog
  },
  filters: {},
  props: {
    successFn: {
      type: Function,
      default: null
    },
    propFilterTeacher: {
      type: [Number, null, undefined],
      default: 0
    },
    initData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      liveModeOption,
      top: '114px',
      liveRoomId: this.$route?.params?.id || '',
      relationTaskMap: {},
      relationTaskNameMap: {},
      sureLoading: false,
      loading: false,
      visible: false,
      list: [],
      scriptId: '',
      search: {
        taskName: '',
        userIds: '',
        time: {
          value: [
            moment().subtract(3, 'month').format('YYYY-MM-DD'),
            moment().format('YYYY-MM-DD')
          ],
          label: 0
        },
        filterTeacher: 0,
        filterRefund: 0
      },
      userArray: [],
      currentPage: 1,
      pageSize: 10,
      success: () => {},
      total: 0,
      selectList: [],
      propFilterTeacher: 0
    }
  },
  computed: {
    selectIdsList() {
      return this.selectList.reduce((pre, next) => {
        pre.push(next.id)
        return pre
      }, [])
    },
    selectedTasks() {
      return (this.selectList || []).map(task => ({
        ...task,
        followUserList: this.getTaskFollowUsers(task)
      }))
    }
  },
  watch: {
    visible: {
      handler(val) {
        if (val) {
          this.search.time.value = [
            moment().subtract(3, 'month').format('YYYY-MM-DD'),
            moment().format('YYYY-MM-DD')
          ]
          val && this.getList()
          val && this.loadUserNoPage()
          this.$nextTick(() => {
            if (this.selectList && this.selectList.length) {
              this.selectedRelationTask()
            }
          })
        }
      },
      deep: true
    },
    propFilterTeacher: {
      handler(val) {
        this.search.filterTeacher = val
        if (this.selectList.length) {
          this.selectedRelationTask()
        }
      }
    },
    initData: {
      handler(val) {
        this.search.filterTeacher = val?.syncTeacherClue || this.propFilterTeacher || 0
        this.search.filterRefund = val?.filterRefund || 0
        if (this.selectList.length) {
          this.selectedRelationTask()
        }
      }
    }
  },
  beforeDestroy() {},
  mounted() {
    this.top = Math.abs(window.innerHeight - 740) / 2 + 'px'
  },
  methods: {
    loadUserNoPage() {
      const params = {
        nickName: ''
      }
      userNoPage(params)
        .then(res => {
          this.userArray = res.data
        })
        .catch(() => {})
    },
    moment,
    getOptionsValueByKey,
    searchFn() {
      this.currentPage = 1
      this.getList()
    },
    async rowClick(row) {
      const index = this.selectIdsList.findIndex(v => v === row.id)
      console.log(index)
      if (index > -1) {
        const removed = this.selectList[index]
        this.selectList.splice(index, 1)
        this.clearTaskRelation(removed)
      } else {
        this.selectList.push(row)
        await this.fetchSingleSelectedRelationTask(row)
      }
    },
    getTaskRelationKey(task) {
      return String(task?.taskId || task?.id || '')
    },
    getTaskFollowUsers(task) {
      const key = this.getTaskRelationKey(task)
      const byId = (this.relationTaskMap && this.relationTaskMap[key]) || []
      if (byId && byId.length) return byId
      const nameKey = task?.taskName ? String(task.taskName) : ''
      if (!nameKey) return []
      return (
        (this.relationTaskNameMap && this.relationTaskNameMap[nameKey]) || []
      )
    },
    clearTaskRelation(task) {
      const relationKey = this.getTaskRelationKey(task)
      if (
        relationKey &&
        this.relationTaskMap &&
        relationKey in this.relationTaskMap
      ) {
        this.$delete(this.relationTaskMap, relationKey)
      }
      const nameKey = task?.taskName ? String(task.taskName) : ''
      if (
        nameKey &&
        this.relationTaskNameMap &&
        nameKey in this.relationTaskNameMap
      ) {
        this.$delete(this.relationTaskNameMap, nameKey)
      }
    },
    async fetchSingleSelectedRelationTask(task) {
      const params = {
        filterTeacher: this.search.filterTeacher,
        filterRefund: this.search.filterRefund,
        taskList: [
          {
            taskCreateId: task.taskCreateId,
            taskId: task.taskId || task.id,
            taskName: task.taskName
          }
        ],
        liveRoomId: this.liveRoomId
      }
      const { code, data } = await selectedRelationTask(params)
      if (code !== 1) {
        return
      }
      ;(data || []).forEach(item => {
        const followList = Array.isArray(item?.followUserList)
          ? item.followUserList
          : item?.followUserId || item?.followUserName
          ? [
              {
                followUserId: item.followUserId,
                followUserName: item.followUserName
              }
            ]
          : []
        const idKeyRaw = item?.taskId || item?.id
        if (idKeyRaw !== undefined && idKeyRaw !== null && idKeyRaw !== '') {
          this.$set(this.relationTaskMap, String(idKeyRaw), followList)
        }
        if (item?.taskName) {
          this.$set(this.relationTaskNameMap, String(item.taskName), followList)
        }
      })
    },
    async selectedRelationTask() {
      if (!this.selectList.length) {
        this.relationTaskMap = {}
        this.relationTaskNameMap = {}
        return
      }
      const params = {
        filterTeacher: this.search.filterTeacher,
        filterRefund: this.search.filterRefund,
        taskList: this.selectList.map(item => ({
          taskCreateId: item.taskCreateId,
          taskId: item.taskId || item.id,
          taskName: item.taskName
        })),
        liveRoomId: this.liveRoomId
      }
      const { code, data } = await selectedRelationTask(params)
      if (code !== 1) {
        this.relationTaskMap = {}
        this.relationTaskNameMap = {}
        return
      }
      const map = {}
      const nameMap = {}
      ;(data || []).forEach(item => {
        const followList = Array.isArray(item?.followUserList)
          ? item.followUserList
          : item?.followUserId || item?.followUserName
          ? [
              {
                followUserId: item.followUserId,
                followUserName: item.followUserName
              }
            ]
          : []
        const idKeyRaw = item?.taskId || item?.id
        if (idKeyRaw !== undefined && idKeyRaw !== null && idKeyRaw !== '') {
          map[String(idKeyRaw)] = followList
        }
        if (item?.taskName) {
          nameMap[String(item.taskName)] = followList
        }
      })
      this.relationTaskMap = map
      this.relationTaskNameMap = nameMap
    },
    removeSelectedTag(tag) {
      const index = this.selectIdsList.findIndex(v => v === tag.id)
      if (index > -1) {
        this.selectList.splice(index, 1)
      }
      this.clearTaskRelation(tag)
      if (!this.selectList.length) {
        this.relationTaskMap = {}
        this.relationTaskNameMap = {}
      }
    },
    sure() {
      if (this.selectList.length > 50) {
        return
      }
      this.success &&
        this.success(
          this.selectList,
          this.search.filterTeacher,
          this.search.filterRefund
        )
    },
    getList() {
      this.loading = true
      const data = {
        pageIndex: this.currentPage,
        pageSize: this.pageSize,
        createUserId: this.search.userIds,
        taskName: this.search.taskName,
        startCreateTime:
          this.search.time.value && this.search.time.value[0]
            ? this.search.time.value[0] + ' 00:00:00'
            : '',
        endCreateTime:
          this.search.time.value && this.search.time.value[1]
            ? this.search.time.value[1] + ' 23:59:59'
            : ''
      }
      saleTaskPage(data)
        .then(res => {
          res.data.items.map(v => {
            v.taskId = v.id
            v.taskCreateId = v.createUserId
          })
          this.list = res.data.items
          this.total = res.data.total
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getList()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1
      this.getList()
    },
    closeFn() {
      this.visible = false
    },
    handleClickSearch() {
      this.searchFn()
    }
  }
}
</script>

<style lang="scss" scoped>
.pr20 {
  padding-right: 20px;
}
.selectTask {
  height: 611px;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  .filterHeader {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 22px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    .formLabel {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 32px;
      margin-right: 8px;
    }
    .checkboxRow {
      width: 100%;
      display: flex;
      align-items: center;
      margin: 8px 0;
    }
    .filterRefundWrapper {
      display: inline-flex;
      align-items: center;
      margin-left: 10px;
    }
    .filterRefundWrapper .el-tooltip {
      margin-left: 4px;
    }
  }
  .myTable {
    width: 100%;
    margin-top: 20px;
    flex: 1;
    min-height: 0;
  }
  .taskLayout {
    display: flex;
    gap: 16px;
    height: 100%;
    min-height: 0;
  }
  .taskLayout__left {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    min-height: 0;
    background: #ffffff;
    border-radius: 6px;
    border: 1px solid #cbcfd3;
    overflow: hidden;
  }
  .taskLayout__right {
    width: 360px;
    flex-shrink: 0;
    min-height: 0;
  }
  .selectedTaskList {
    border: 1px solid #ebeef5;
    border-radius: 8px;
    padding: 12px;
    box-sizing: border-box;
    background: #fff;
    display: flex;
    flex-direction: column;
  }
  .selectedTaskList__title {
    color: #303133;
    font-size: 14px;
    font-weight: 600;
    line-height: 22px;
    margin-bottom: 8px;
  }
  .selectedTaskList__summary {
    color: #606266;
    font-size: 13px;
    line-height: 20px;
    margin-bottom: 12px;
  }
  .selectedTaskTableHeader {
    width: 100%;
    display: grid;
    grid-template-columns: 160px 1fr;
    gap: 12px;
    padding: 10px 12px;
    border-radius: 6px;
    background: #f7f8fa;
    margin-bottom: 10px;
    color: #606266;
    font-weight: 600;
    box-sizing: border-box;
  }
  .selectedTaskTableHeader__cell {
    min-width: 0;
    line-height: 20px;
  }
  .selectedTaskTableHeader__follow {
    display: flex;
    align-items: center;
  }
  .selectedTaskList__body {
    width: 100%;
    overflow-y: auto;
    flex: 1;
    min-height: 0;
  }
  .selectedTaskRow {
    width: 100%;
    display: grid;
    grid-template-columns: 160px 1fr;
    gap: 12px;
    align-items: flex-start;
    padding: 4px 0;
    border-bottom: 1px solid #f5f7fa;

    &:last-child {
      border-bottom: none;
      padding-bottom: 0;
    }
  }
  .selectedTaskRow__task {
    min-width: 0;
    margin-top: 4px;

    ::v-deep .el-tag {
      width: 100%;
      max-width: 100%;
      display: flex;
      align-items: center;
      box-sizing: border-box;
      overflow: hidden;
      margin-right: 0 !important;
      margin-bottom: 0 !important;
    }

    ::v-deep .el-tag__content {
      flex: 1;
      min-width: 0;
      display: flex;
      align-items: center;
      vertical-align: top;
    }

    ::v-deep .el-tag .el-icon-close {
      flex-shrink: 0;
      margin-left: 6px;
    }
  }
  .selectedTaskNameText {
    flex: 1;
    min-width: 0;
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: top;
  }
  .selectedTaskRow__follow {
    min-width: 0;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    align-content: center;
  }
  .followUserItem {
    display: inline-flex;
    margin: 4px 8px 4px 0;

    ::v-deep .el-tag {
      max-width: 100%;
      margin-bottom: 0 !important;
    }

    ::v-deep .el-tag__content {
      display: inline-block;
      max-width: 180px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      vertical-align: top;
    }
  }
  .selectedTaskRow__followEmpty {
    color: #c0c4cc;
    line-height: 24px;
    padding-top: 2px;
  }
  .pagination {
    height: 48px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    // justify-content: right;
  }
}
.liveType,
.liveMode {
  display: inline-block;
  // display: flex;
  // align-items: center;
  // justify-content: center;
  padding: 0 8px;
  border-radius: 13px;
  font-size: 10px;
  font-family: MicrosoftYaHei;
  height: 24px;
  line-height: 24px;
  .liveTypeicon,
  .liveModeicon {
    width: 13px;
    height: 13px;
    font-size: 13px;
    margin-right: 4px;
  }
}
.liveType0 {
  background: #eef2f9;
  color: #717f99;
}
.liveType1 {
  background: #e7f0ff;
  color: #1778ff;
}
.liveType2 {
  background: #fff2e6;
  color: #ff7d00;
}
.liveType3 {
  background: #feecec;
  color: #f53f3f;
}
.liveType9 {
  background: #f5f5f5;
  color: #999999;
}
.liveModePERSON_LIVE {
  background: #e7f0ff;
  color: #0c6fff;
}
.liveModeAI_LIVE {
  background: #e6f7ea;
  color: #00b42a;
}
.liveModeDIGITAL_PERSON_LIVE {
  background: #e7f9ff;
  color: #0099ff;
}
.tipsError {
  color: red;
  .tips {
    padding-left: 10px;
    color: #777;
  }
}
</style>
